module.exports = __webpack_public_path__ + "static/media/painManagementImage3.dbb657ba.png";